// extracted by mini-css-extract-plugin
module.exports = {"tile":"WorkTile_tile__1BDML","title":"WorkTile_title__3AGVY","list":"WorkTile_list__3Pvs0","item":"WorkTile_item__2mX_0"};